import { Component } from 'react';
import { sendNavigateToUrl } from '../../../services/postMessageService';
import type { Button, Carousel, CarouselData } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';
import { CarouselContainer } from './CarouselContainer';
import { CarouselList } from './CarouselList';

class ImageCarousel extends Component<
  {
    data: CarouselData;
    options?: Carousel['options'];
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  },
  { buttonIndex: number }
> {
  constructor(props: {
    data: CarouselData;
    options: Carousel['options'];
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  }) {
    super(props);
    this.state = {
      buttonIndex: 0,
    };
    this.moveLeftClickHandler.bind(this);
    this.moveRightClickHandler.bind(this);
  }

  handleClick = (clickedButton: Button) => {
    const { submitHandler } = this.props;
    if (clickedButton.url) {
      sendNavigateToUrl(
        clickedButton.url,
        clickedButton?.options?.webclient?.urlOpenMethod,
      );
    }
    submitHandler({ value: clickedButton });
  };

  moveLeftClickHandler = () => {
    const { buttonIndex } = this.state;
    const leftLimit = 0;
    if (buttonIndex - 1 < leftLimit) {
      return;
    }
    this.setState({
      buttonIndex: buttonIndex - 1,
    });
  };

  moveRightClickHandler = () => {
    const {
      data: { elements },
    } = this.props;
    const { buttonIndex } = this.state;

    const rightLimit = elements.length - 1;
    if (buttonIndex + 1 > rightLimit) {
      return;
    }
    this.setState({
      buttonIndex: buttonIndex + 1,
    });
  };

  render() {
    const {
      data: { elements },
      options,
      scheme,
    } = this.props;

    const { templateType = 'carousel' } = options?.webclient || {};

    return (
      <>
        {templateType !== 'list' ? (
          <CarouselContainer
            handleClick={this.handleClick}
            elements={elements}
            scheme={scheme}
          />
        ) : (
          <CarouselList
            handleClick={this.handleClick}
            elements={elements}
            scheme={scheme}
          />
        )}
      </>
    );
  }
}

export default ImageCarousel;
